(() => {
  const runtime = window.ThemeRuntime || new EventTarget();
  window.ThemeRuntime = runtime;

  runtime.on = (eventName, listener, options) => {
    runtime.addEventListener(eventName, listener, options);
    return () => runtime.removeEventListener(eventName, listener, options);
  };
  runtime.emit = (eventName, detail) => runtime.dispatchEvent(new CustomEvent(eventName, { detail }));

  window.debounce ||= (callback, wait) => {
    let timeoutId;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => callback(...args), wait);
    };
  };

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  let focusTrap;

  window.trapFocus ||= (container, elementToFocus = container) => {
    window.removeTrapFocus();
    const handleKeydown = (event) => {
      if (event.key !== 'Tab') return;
      const focusable = [...container.querySelectorAll(focusableSelector)].filter(
        (element) => !element.hasAttribute('hidden') && element.offsetParent !== null
      );
      if (!focusable.length) return event.preventDefault();

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    focusTrap = { handleKeydown };
    document.addEventListener('keydown', handleKeydown);
    elementToFocus?.focus();
  };

  window.removeTrapFocus ||= (elementToFocus) => {
    if (focusTrap) document.removeEventListener('keydown', focusTrap.handleKeydown);
    focusTrap = undefined;
    elementToFocus?.focus();
  };

  window.onKeyUpEscape ||= (event) => {
    if (event.code !== 'Escape') return;
    const details = event.target.closest('details[open]');
    if (!details) return;
    details.removeAttribute('open');
    details.querySelector('summary')?.focus();
  };

  window.pauseAllMedia ||= () => {
    document.querySelectorAll('[data-media-id] video, [data-media-id] audio').forEach((media) => media.pause());
    document.querySelectorAll('[data-media-id] iframe').forEach((frame) => {
      frame.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      frame.contentWindow?.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('product-model').forEach((model) => model.pause?.());
  };

  window.PUB_SUB_EVENTS ||= {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    cartError: 'cart-error',
  };
  window.subscribe ||= (eventName, callback) => runtime.on(eventName, (event) => callback(event.detail));
  window.publish ||= (eventName, detail = {}) => runtime.emit(eventName, detail);
  window.fetchConfig ||= (type = 'json') => ({
    method: 'POST',
    headers: { Accept: `application/${type}`, 'Content-Type': 'application/json' },
  });
  window.formatWithDelimiters ||= (number, precision = 2, thousands = ',', decimal = '.') => {
    if (isNaN(number) || number == null) return '0';
    const fixed = (Number(number) / 100).toFixed(precision);
    const parts = fixed.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    const cents = parts[1] ? `${decimal}${parts[1]}` : '';
    return dollars + cents;
  };
  window.formatMoney ||= (cents, format = '${{amount}}') => {
    const placeholderMatch = String(format).match(/\{\{\s*(\w+)\s*\}\}/);
    const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
    let value;
    switch (placeholder) {
      case 'amount_no_decimals':
        value = window.formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = window.formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = window.formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = window.formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = window.formatWithDelimiters(cents, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        value = window.formatWithDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = window.formatWithDelimiters(cents, 2);
    }
    return placeholderMatch ? format.replace(placeholderMatch[0], value) : format;
  };

  if (!window.SearchForm) {
    window.SearchForm = class extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');
        this.resetButton = this.querySelector('button[type="reset"]');
        this.onFormReset = this.onFormReset.bind(this);
        this.input?.addEventListener('input', () => this.toggleResetButton());
        this.resetButton?.addEventListener('click', this.onFormReset);
      }

      onFormReset(event) {
        event?.preventDefault();
        this.input?.focus();
        this.input.value = '';
        this.toggleResetButton();
      }

      shouldResetForm() {
        return !this.input?.value;
      }

      toggleResetButton() {
        if (this.resetButton) this.resetButton.classList.toggle('hidden', !this.input?.value);
      }
    };
  }
})();
